import { render, staticRenderFns } from "./MEM_heroLanding.vue?vue&type=template&id=24d23bf6&"
import script from "./MEM_heroLanding.vue?vue&type=script&lang=js&"
export * from "./MEM_heroLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports